import { render, staticRenderFns } from "./PaymentCardWalletBlock.vue?vue&type=template&id=62554e02&scoped=true"
import script from "./PaymentCardWalletBlock.vue?vue&type=script&lang=js"
export * from "./PaymentCardWalletBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62554e02",
  null
  
)

export default component.exports